import { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./ViewMrfPage.css";
import { AuthContext } from "../../../context/AuthContext";
import ViewOneMrf from "../viewonemrf/ViewOneMrf";
import mailIcon from "../../../assests/mail.png";
import { Select, DatePicker } from "antd";
import { Table, Input, Button, Typography, Modal, Pagination, Checkbox } from "antd";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const { Text, Title, Space } = Typography;
const { Option } = Select;

export default function ViewMrfPage() {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const handleOpenModal = (mrfNumber) => {
        setCandidateEmail({ ...candidateEmail, mrfNumber, isSpecialCase: false });
        setIsModalVisible(true);
    };
    const handleCloseModal = () => {
        setIsModalVisible(false);
    };
    const { authData, backUrl } = useContext(AuthContext);
    const [filterStatus, setFilterStatus] = useState("Open");
    const [requisitions, setRequisitions] = useState([]);
    const [departmentNames, setDepartmentNames] = useState([]);
    const [designationNames, setDesignationNames] = useState([]);
    const [organizationNames, setOrganizationNames] = useState([]);
    const [designations, setDesignations] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0); // ✅ total count from API
    const [particular, setParticular] = useState({ status: false, data: "" });
    const [emailSending, setEmailSending] = useState(false);
    const [allDepartmentNames, setAllDepartmentNames] = useState([]);

    const [selectedDepartment, setSelectedDepartment] = useState(null)


    // const [showEmailArea, setShowEmailArea] = useState(false);
    const [candidateEmail, setCandidateEmail] = useState({ email: "", mrfNumber: "", is_special_case: false });

    const [filters, setFilters] = useState({
        organization: '',
        department: '',
        submission_date_after: '',
        submission_date_before: '',
        status: '',
        designation: ''
    });

    const BASE_URL = backUrl;

    const columns = [
        {
            title: <span style={{ color: "white" }}>MRF Number</span>,
            dataIndex: 'mrf_number',
            key: 'mrf_number',
            render: (text, record) => (
                <a onClick={() => handleClickOne(record.mrf_number)}>{text}</a>
            ),
            fixed: 'left',
        },
        {
            title: <span style={{ color: "white" }}>Organization</span>,
            dataIndex: 'organisation',
            key: 'organisation',
            render: (org) => getOrganizationName(org),
        },
        {
            title: <span style={{ color: "white" }}>Department</span>,
            dataIndex: 'department',
            key: 'department',
            render: (dep) => getDepartmentName(dep),
        },
        {
            title: <span style={{ color: "white" }}>Designation</span>,
            dataIndex: 'designation',
            key: 'designation',
            render: (des) => getDesignationTitle(des),
        },
        {
            title: <span style={{ color: "white" }}>Vacancies</span>,
            dataIndex: 'no_of_vacancies',
            key: 'no_of_vacancies',
        },
        ...(filterStatus === "Open" || filterStatus === "On-Hold" ? [{
            title: <span style={{ color: "white" }}>Assigned Date</span>,
            dataIndex: 'mrf_allocated_date',
            key: 'mrf_allocated_date',
            render: (d) => d ? dayjs(d).format("DD MMM YYYY") : "-",
        }] : []),
        ...(filterStatus === "Close" ? [
            {
                title: <span style={{ color: "white" }}>Assigned Date</span>,
                dataIndex: 'mrf_allocated_date',
                key: 'mrf_allocated_date',
                render: (d) => d ? dayjs(d).format("DD MMM YYYY") : "-",
            },
            {
                title: <span style={{ color: "white" }}>Closed Date</span>,
                dataIndex: 'mrf_closed_date',
                key: 'mrf_closed_date',
                render: (d) => d ? dayjs(d).format("DD MMM YYYY") : "-",
            },
            {
                title: <span style={{ color: "white" }}>Turnaround Days</span>,
                dataIndex: 'days_assigned_to_close',
                key: 'days_assigned_to_close',
                render: (v) => v !== null && v !== undefined ? `${v} Days` : "-",
            }
        ] : []),
        {
            title: <span style={{ color: "white" }}>Current Status</span>,
            dataIndex: 'mrf_status',
            key: 'mrf_status',
            render: (_, record) => (
                <>
                    <center><div>{record.mrf_status === "Close" ? "Closed" : record.mrf_status || "Pending"}</div></center>
                </>
            )
        },
        {
            title: <span style={{ color: "white" }}>Mail</span>,
            dataIndex: 'mail',
            key: 'mail',
            render: (_, req) => (
                <>
                    <Button type="default" onClick={() => handleOpenModal(req.mrf_number)}>
                        send mail <img className="mail-icon" src={mailIcon} alt="mail" />
                    </Button>

                    <Modal
                        title={`Send Mail for MRF: ${candidateEmail.mrfNumber}`}
                        open={isModalVisible}
                        onCancel={handleCloseModal}
                        footer={[
                            <Button key="cancel" onClick={handleCloseModal}>
                                Cancel
                            </Button>,
                            <Button
                                key="send"
                                type="primary"
                                onClick={handleSendMail}
                                disabled={emailSending}
                                style={{ backgroundColor: '#0e497b', color: 'white' }}
                            >
                                {emailSending ? "Sending..." : "Send"}
                            </Button>,
                        ]}
                    >
                        <Input
                            type="email"
                            placeholder="Enter candidate email"
                            value={candidateEmail.email}
                            onChange={(e) =>
                                setCandidateEmail({ ...candidateEmail, email: e.target.value })
                            }
                        />
                        <Checkbox
                            style={{ marginTop: "15px" }}
                            checked={candidateEmail.is_special_case}
                            onChange={(e) =>
                                setCandidateEmail({
                                    ...candidateEmail,
                                    is_special_case: e.target.checked,
                                })
                            }
                        >
                            Special Case
                        </Checkbox>
                    </Modal>
                </>
            ),
        },
        {
            title: <span style={{ color: "white" }}>Sent</span>,
            dataIndex: 'total_invites_sent',
            key: 'total_invites_sent',
        },
        {
            title: <span style={{ color: "white" }}>Acknowledged</span>,
            dataIndex: 'total_forms_submitted',
            key: 'total_forms_submitted',
        },
    ];

    const handleDownloadExcel = () => {
        if (!requisitions || requisitions.length === 0) {
            alert("No data available to download");
            return;
        }

        const excelData = requisitions.map((item) => ({
            "MRF Number": item.mrf_number,
            "Organization": getOrganizationName(item.organisation),
            "Department": getDepartmentName(item.department),
            "Designation": getDesignationTitle(item.designation),
            "Vacancies": item.no_of_vacancies,
            "Assigned Date": item.mrf_allocated_date ? dayjs(item.mrf_allocated_date).format("DD/MM/YYYY") : "-",
            "Closed Date": item.mrf_closed_date ? dayjs(item.mrf_closed_date).format("DD/MM/YYYY") : "-",
            "Turnaround Days": item.days_assigned_to_close !== null && item.days_assigned_to_close !== undefined ? `${item.days_assigned_to_close} Days` : "-",
            "Current Status": item.mrf_status === "Close" ? "Closed" : item.mrf_status || "Pending",
            "Total Invites Sent": item.total_invites_sent,
            "Acknowledged": item.total_forms_submitted,
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Requisitions");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        saveAs(blob, `MRF_Requisitions_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };


    const fetchRequisitions = async (page = 1, customFilters = filters) => {
        setLoading(true);
        const params = new URLSearchParams();
        params.append("page", page);

        if (customFilters.department) params.append("department", customFilters.department);
        if (customFilters.organization) params.append("organisation", customFilters.organization);
        if (customFilters.status) params.append("status", customFilters.status);
        if (customFilters.submission_date_after && customFilters.submission_date_before) {
            params.append("submission_date_after", customFilters.submission_date_after);
            params.append("submission_date_before", customFilters.submission_date_before);
        }
        if (customFilters.designation) params.append("designation", customFilters.designation);

        const apiUrl = `${BASE_URL}/api/emp/manpowerrequisitions/?mrf_status=${filterStatus}`;

        try {
            const res = await axios.get(apiUrl, {
                headers: { Authorization: `Bearer ${authData?.access}` },
                params,
            });
            setRequisitions(res.data.results);
            setCurrentPage(page);
            setTotal(res.data.count); // ✅ use API total count
        } catch (err) {
            console.error("Error fetching requisitions:", err);
            setError("Failed to load requisitions");
        } finally {
            setLoading(false);
        }
    };

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/organisations/`);
            setOrganizationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchDepartments = async (v) => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/?organisation=${v}`);
            setDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchAllDepartments = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/departments/`);
            setAllDepartmentNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };


    const fetchAllDesignations = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/designations/`);
            setDesignationNames(res.data.results);
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    const fetchDesignations = async (v) => {
        try {
            const res = await axios.get(`${BASE_URL}/api/emp/designations/?department=${v}`);
            setDesignations(res.data.results)
        } catch (err) {
            console.error("Failed to fetch designations:", err);
        }
    };

    useEffect(() => {
        if (authData?.access) {
            fetchRequisitions(1);
            fetchAllDepartments();
            fetchOrganizations();
            fetchAllDesignations();
        }
    }, [authData]);

    useEffect(() => {
        fetchRequisitions(1);
    }, [filters, filterStatus]);

    const getDepartmentName = (id) => allDepartmentNames.find((d) => d.id === id)?.name || "N/A";
    const getDesignationTitle = (id) => designationNames.find((d) => d.id === id)?.name || "N/A";
    const getOrganizationName = (id) => organizationNames.find((o) => o.id === id)?.name || "N/A";

    const handleClickOne = (mrfno) => {
        setParticular({ status: true, data: mrfno });
    };

    const handleSendMail = async () => {
        if (!candidateEmail.email) {
            alert("Please enter candidate email");
            return;
        }

        setEmailSending(true);
        try {
            const res = await axios.post(
                `${BASE_URL}/api/emp/manpowerrequisitions/${candidateEmail.mrfNumber}/send_interview_link/`,
                { email_id: candidateEmail.email, special_case: candidateEmail.is_special_case },
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            console.log(res.data);
            setCandidateEmail({ ...candidateEmail, email: "" });
            await fetchRequisitions(currentPage);
        } catch (err) {
            console.error("Error sending email:", err);
            const backendMessage = err.response?.data?.message;
            alert(backendMessage || err.message || "Something went wrong");
        } finally {
            setEmailSending(false);
        }
    };

    return (
        <div className="container mt-4">
            {particular.status === false ? (
                <>
                    {/* ── Page Title ── */}
                    <div style={{ textAlign: "center", marginBottom: 20 }}>
                        <h5 style={{ fontWeight: 700, color: "#0e497b", fontSize: 20, margin: 0 }}>View Requisitions</h5>
                    </div>

                    {/* ── Filter Card ── */}
                    <div style={{
                        background: "#fff",
                        border: "1px solid #e8e8e8",
                        borderRadius: 10,
                        padding: "20px 24px 16px",
                        marginBottom: 20,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                    }}>
                        {/* Row 1: Org / Dept / Designation */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 4 }}>Organization</label>
                                <Select
                                    placeholder="-- Select organization --"
                                    value={filters.organization || undefined}
                                    onChange={(value) => {
                                        setFilters({ ...filters, organization: value });
                                        fetchDepartments(value);
                                    }}
                                    style={{ width: "100%" }}
                                    allowClear
                                >
                                    {organizationNames.map((item) => (
                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                    ))}
                                </Select>
                            </div>
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 4 }}>Department</label>
                                <Select
                                    placeholder="-- Select Department --"
                                    value={filters.department || undefined}
                                    onChange={(value) => {
                                        setFilters({ ...filters, department: value });
                                        setSelectedDepartment(value);
                                        fetchDesignations(value);
                                    }}
                                    style={{ width: "100%" }}
                                    allowClear
                                >
                                    {departmentNames.map((item) => (
                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                    ))}
                                </Select>
                            </div>
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 4 }}>Designation</label>
                                <Select
                                    placeholder="-- Select Designation --"
                                    value={filters.designation || undefined}
                                    onChange={(value) => setFilters({ ...filters, designation: value })}
                                    style={{ width: "100%" }}
                                    allowClear
                                >
                                    {designations.map((item) => (
                                        <Option key={item.id} value={item.id}>{item.name}</Option>
                                    ))}
                                </Select>
                            </div>
                        </div>

                        {/* Row 2: Date From / Date To / Download Excel */}
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, alignItems: "flex-end" }}>
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 4 }}>Submission From</label>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={filters.submission_date_after ? dayjs(filters.submission_date_after) : null}
                                    onChange={(date, dateString) => setFilters({ ...filters, submission_date_after: dateString })}
                                    format="YYYY-MM-DD"
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#555", display: "block", marginBottom: 4 }}>Submission To</label>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    value={filters.submission_date_before ? dayjs(filters.submission_date_before) : null}
                                    onChange={(date, dateString) => setFilters({ ...filters, submission_date_before: dateString })}
                                    format="YYYY-MM-DD"
                                />
                            </div>
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <Button
                                    type="primary"
                                    style={{ backgroundColor: "#0e497b", borderColor: "#0e497b", height: 32, paddingInline: 20 }}
                                    onClick={handleDownloadExcel}
                                >
                                    Download Excel
                                </Button>
                            </div>
                        </div>
                    </div>

                    {/* ── Status Tab Bar ── */}
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 0,
                        marginBottom: 20,
                        background: "#f0f4f8",
                        borderRadius: 10,
                        padding: "6px 8px",
                        width: "fit-content",
                        margin: "0 auto 20px auto",
                        boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                    }}>
                        {[
                            { label: "Open", value: "Open" },
                            { label: "Closed", value: "Close" },
                            { label: "Hold", value: "On-Hold" },
                        ].map(({ label, value }) => (
                            <button
                                key={value}
                                onClick={() => setFilterStatus(value)}
                                style={{
                                    background: filterStatus === value ? "#0e497b" : "transparent",
                                    color: filterStatus === value ? "#fff" : "#0e497b",
                                    border: "none",
                                    borderRadius: 7,
                                    padding: "7px 32px",
                                    fontWeight: 600,
                                    fontSize: 14,
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    minWidth: 100,
                                    outline: "none",
                                    letterSpacing: "0.3px",
                                    boxShadow: filterStatus === value ? "0 2px 6px rgba(14,73,123,0.35)" : "none",
                                }}
                            >
                                {label}
                            </button>
                        ))}
                    </div>

                    {loading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p className="text-danger">{error}</p>
                    ) : (
                        <>
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={requisitions.length > 0 ? requisitions : []}
                                    rowKey={(record) => record.id}
                                    bordered
                                    pagination={false}
                                    scroll={{ x: 'max-content' }}
                                    style={{ marginTop: 16 }}
                                    locale={{
                                        emptyText: <Text type="secondary">No requisitions found.</Text>,
                                    }}
                                    components={{
                                        header: {
                                            cell: (props) => <th {...props} style={{ backgroundColor: "#0e497b", color: "#fff" }} />,
                                        },
                                    }}
                                />
                            </div>

                            {/* ✅ Fixed Pagination */}
                            <Pagination
                                current={currentPage}
                                pageSize={10} // API page_size (adjust if different)
                                total={total}
                                showSizeChanger={false}
                                onChange={(page) => fetchRequisitions(page)}
                                style={{ marginTop: 16, textAlign: "right" }}
                            />
                        </>
                    )}
                </>
            ) : (
                <ViewOneMrf data={particular.data} />
            )}
        </div>
    );
}
